import { render, staticRenderFns } from "./BelposhtaTableUser.vue?vue&type=template&id=438c1268&scoped=true"
import script from "./BelposhtaTableUser.vue?vue&type=script&lang=js"
export * from "./BelposhtaTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438c1268",
  null
  
)

export default component.exports